import { ValidationError } from "sequelize"
import {
    CcRequirementSmartCompliance,
    CcRequirementSmartComplianceCreate,
    CcRequirementSmartComplianceSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, validate, search,
} from "client/store/utils"
import { LangType, SmartCompliancesType } from "client/store"
import {
    CcRequirementSmartComplianceList,
    CcRequirementSmartComplianceFilters,
    CcRequirementSmartComplianceValidation,
} from "./types"


export const GetDefaultSmartCompliances = (
    complianceList: CcRequirementSmartComplianceList,
    complianceIds: readonly number[],
) => {
    const defaultCompliances: SmartCompliancesType = {}
    complianceIds.forEach((complianceId) => {
        const compliance = complianceList[complianceId]
        if (compliance.default) defaultCompliances[compliance.id] = true
    })
    return defaultCompliances
}

export const LoadCcRequirementSmartCompliances = (
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementSmartCompliance/accountId/${accountId}/projectId/${projectId}`)
    .then((compliances: CcRequirementSmartCompliance[]) => {
        const complianceList: CcRequirementSmartComplianceList = {}
        compliances.forEach((compliance) => {
            complianceList[compliance.id] = compliance
        })
        return complianceList
    })
)

export const LoadCcRequirementSmartComplianceById = (
    complianceId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementSmartCompliance/id/${complianceId}/accountId/${accountId}/projectId/${projectId}`)
    .then((compliance: CcRequirementSmartCompliance) => compliance)
)

export const SaveCcRequirementSmartCompliance = (
    id: number,
    compliance: CcRequirementSmartComplianceCreate,
    lang: LangType,
) => {
    const data: CcRequirementSmartComplianceSave = {
        id,
        compliance,
    }
    return POST(
        "/ccRequirementSmartCompliance/save",
        JSON.stringify(data),
    ).then((res) => {
        const newCompliance = res as CcRequirementSmartCompliance
        const error = res as ValidationError
        return {
            newComplianceId: newCompliance.id || null,
            validation: <CcRequirementSmartComplianceValidation>validate(error, lang),
        }
    })
}

export const DeleteCcRequirementSmartCompliance = (complianceId: number) => (
    DELETE(`/ccRequirementSmartCompliance/delete/${complianceId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcRequirementSmartCompliances = (
    accountId: number,
    projectId: number,
    defaultCompliancesAssigned: boolean,
) => (
    GET(`/ccRequirementSmartCompliance/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultCompliancesAssigned}`)
    .then((success: boolean) => success)
)

export const SortCcRequirementSmartCompliance = (
    compliances: CcRequirementSmartCompliance[],
    sortColumn: keyof CcRequirementSmartCompliance,
    sortOrder: OrderType,
    filters: CcRequirementSmartComplianceFilters,
) => {
    const compliancesFiltered = compliances.filter((compliance) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, compliance)
        return showRow
    })
    compliancesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const complianceIds: number[] = []
    compliancesFiltered.forEach((compliance) => complianceIds.push(compliance.id))

    return complianceIds
}
